<template>
	<div class="wrapBox">
		<navheader current="3"></navheader>
		<div class="bannerBox1">
			<div class="bannerCtx">
				<img  src="../assets/images/tj/banner222.png" class="imgsize"/>
				<div class="text">
					<div>VIP体检</div>
					<div class="subtext">您信任的私人订制医疗服务</div>
				</div>
			</div>
			<div class="iconBox">
				<div class="iconItem" v-for="(item,index) in iconList">
					<div class="imgBox">
						<img  :src="item.url" class="iconImg"/>
					</div>
					<div class="name">{{item.name}}</div>
				</div>
			</div>
		</div>
		<div class="teamBox">
			<div class="flex1">
				<img  src="../assets/images/tj/image31.png"  class="borderimg1"/>
				<div class="teamtitle">健康管理团队</div>
			</div>
			<div class="fuhao">=</div>
			<div class="flex1">
				<img  src="../assets/images/tj/image32.png"  class="borderimg"/>
				<div class="sub">1名家庭医生</div>
			</div>
			<div class="fuhao">+</div>
			<div class="flex1">
				<img  src="../assets/images/tj/image33.png"  class="borderimg"/>
				<div class="sub">1名健康秘书</div>
			</div>
			<div class="fuhao">+</div>
			<div class="flex1">
				<img  src="../assets/images/tj/image34.png"  class="borderimg"/>
				<div class="sub">8名家庭成员</div>
			</div>
		</div>
		<div class="MemberBenefits">
			<div class="title">会员尊享权益</div>
			<div class="ctxBox">
				<div class="subTitle">就诊优惠</div>
				<div class="textBox">门诊挂号费尊享员工价 <span>120 元！</span></div>
				<div class="textBox">诊疗费、检查检验费员工折扣价 <span> 5 折！ </span></div>
				<div class="textBox">外院专家门诊挂号费1200元 <span>每年赠送3次！</span></div>
			</div>
			<div class="ctxBox">
				<div class="subTitle">体检优惠</div>
				<div class="textBox">定制体检套餐（8000元/成人） <span>每年赠送3次！</span></div>
			</div>
			<div class="ctxBox">
				<div class="subTitle">VVIP权益</div>
				<div class="textBox">尊享SIMC VVIP通道，包括医疗资源、就诊通道、陪诊服务等</div>
			</div>
		</div>
		<div class="MemberBenefits">
			<div class="title">入会收费标准</div>
			<div class="FeeStandards">
				<div class="first">
					<div class="title">逸享会员</div>
					<div class="ctxbox">
						<div>
							<i class="el-icon-success" ></i>
							<span>无入会费</span>
						</div>
						<div >
							<i class="el-icon-success" ></i>
							<span>1年服务年限</span>
						</div>
						<div >
							<i class="el-icon-success" ></i>
							<span>5万/年服务费</span>
						</div>
					</div>
				</div>
				<div class="first second">
					<div class="title">终身会员</div>
					<div class="ctxbox">
						<div>
							<i class="el-icon-success"></i>
							<span>50万入会费<b>/仅限50席</b></span>
						</div>
						<div >
							<i class="el-icon-success"></i>
							<span>终身服务</span>
						</div>
						<div >
							<i class="el-icon-success" ></i>
							<span>无服务费</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footercommon></footercommon>
	</div>
</template>

<script>
	import navheader from "../components/navheader.vue";
	import footercommon from "../components/footercommon.vue";
	export default{
		components: { navheader,footercommon},
		props:['current'],
		data(){
			return{
				iconList:[
					{url:require('../assets/images/tj/icon1.png'),name:'健康评估'},
					{url:require('../assets/images/tj/icon2.png'),name:'免费问诊'},
					{url:require('../assets/images/tj/icon3.png'),name:'重疾保障'},
					{url:require('../assets/images/tj/icon4.png'),name:'名医专家会诊'},
					{url:require('../assets/images/tj/icon5.png'),name:'全程陪诊'},
					{url:require('../assets/images/tj/icon6.png'),name:'慢病追踪'},
					{url:require('../assets/images/tj/icon7.png'),name:'VVIP就诊通道'},
					{url:require('../assets/images/tj/icon8.png'),name:'高级会员沙龙'},
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
.bannerBox1{
		.bannerCtx{
			min-width: $commoneWidth;
			margin: 0 auto;
			position: relative;
			height: 22.9375rem; /* 367px */
			.imgsize{
				width: 100%;
				height: 22.9375rem; /* 367px */
			}
			img{
				position: absolute;
				right: 0;
			}
			.text{
				position: absolute;
				left: 5.75rem; /* 92px */
				font-size: 4rem; /* 64px */
				font-weight: 800;
				top: 7.5rem; /* 120px */
				color:#242F2F;
				.subtext{
					font-size: 2.25rem; /* 36px */
					font-weight: 500;
				}
			}
		}
	}
.iconBox{
	box-shadow: 0px 0.25rem 2.2625rem 0px rgba(12, 90, 85, 0.14); /* 4px 36.2px */
	margin: 4.5rem; /* 72px */
	border-radius: 1.5rem; /* 24px */
	display: flex;
	flex-wrap: wrap;
	padding: 3.125rem 0 0.625rem 0; /* 50px 0 10px 0 */
	margin-top: -4.375rem; /* -70px */
	z-index:99;
	position: relative;
	background-color: #fff;
	.iconItem{
		width: 25%;
		display: flex;
		flex-direction: column;
		text-align: center;
		.iconImg{
			width: 5.5rem; /* 88px */
			height: 5.5rem; /* 88px */
		}
		.imgBox{
			margin-bottom: 1rem; /* 16px */
		}
		.name{
			margin-bottom: 4.8125rem; /* 77px */
			font-size: 1.875rem; /* 30px */
			font-weight: 600;
			line-height: 2.25rem; /* 36px */
			color:$fintColor;
		}
	}
}
.MemberBenefits{
	.title{
		text-align: center;
		color:$baseColor;
		font-size: 2.625rem; /* 42px */
		font-weight: 800;
	}
	.ctxBox{
		margin: 8.125rem; /* 130px */
		background-color: $bgcolor;
		border-radius: 1.375rem; /* 22px */
		padding: 5.3125rem 0 2.5rem 0; /* 85px 0 40px 0 */
		text-align: center;
		position: relative;
		.subTitle{
			position: absolute;
			background-color:$baseColor;
			color:#fff;
			font-size: 2rem; /* 32px */
			font-weight: 600;
			width: 12.125rem; /* 194px */
			line-height: 5rem; /* 80px */
			border-radius: 0px 1.375rem 1.375rem 1.375rem; /* 0px 22px 22px 22px */
			top: -2.5rem; /* -40px */
			left: -1.25rem; /* -20px */
		}
		.textBox{
			color:$fintColor;
			font-size: 2.25rem; /* 36px */
			margin-bottom: 3rem; /* 48px */
			span{
				font-size: 3rem; /* 48px */
				font-weight: 1000;
				color:$baseColor;
				display: inline-block;
				margin-left: 2.1875rem; /* 35px */
			}
		}
	}
}
.FeeStandards{
	min-width: $commoneWidth;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	margin-bottom: 3.75rem; /* 60px */
	.first{
		box-shadow: 0px 0.25rem 2.2625rem 0px rgba(12, 90, 85, 0.14); /* 4px 36.2px */
		width: 19.9375rem; /* 319px */
		height: 21.5625rem; /* 345px */
		margin: 5rem; /* 80px */ 
		border-radius: 0px 1.375rem 1.375rem 1.375rem; /* 0px 22px 22px 22px */
		.title{
			background-color:#4176DB;
			color:#fff;
			font-size: 2rem; /* 32px */
			line-height: 5rem; /* 80px */
			border-radius: 0px 1.375rem 1.375rem 1.375rem; /* 0px 22px 22px 22px */
		}
		&.second .title{
			background-color: $baseColor;
		}
		.ctxbox{
			padding: 3.4375rem 0 0px 2.8125rem; /* 55px 0 0px 45px */
			.el-icon-success{
				color:#FFA132;
				font-size: 1.875rem; /* 30px */
			}
			div{
				display: flex;
				align-items: center;
				color:$fintColor; 
				font-size: 1.375rem; /* 22px */
				font-weight: 600;
				margin-bottom: 1.875rem; /* 30px */
				span{
					display: inline-block;
					margin-left: 1.25rem; /* 20px */
					b{
						font-size: 1rem; /* 16px */
					}
				}
			}
		}
	}
}
.teamBox{
	background-image: url('../assets/images/lnbg.png');
	background-repeat: no-repeat;
	background-size: 100%;
	padding: 6.25rem 17.5rem; /* 100px 280px */
	margin: 9.375rem 0; /* 150px 0 */
	display: flex;
	align-items: center;
	.teamtitle{
		font-size: 2rem; /* 32px */
		font-weight: 600;
		line-height: 2.25rem; /* 36px */
		color:$baseColor;
		white-space: nowrap; /* 防止换行 */
	}
	.fuhao{
		font-size: 6.25rem; /* 100px */
		color:$baseColor;
		font-weight: 1000;
		margin: 0 4.375rem; /* 0 70px */
		margin-top: -4.375rem; /* -70px */
	}
	.borderimg{
		border: 0.1875rem solid $baseColor; /* 3px */
		border-radius: 50%;
		width: 10rem; /* 160px */
		height: 10rem; /* 160px */
		
	}
	.borderimg1{
		width: 11.75rem; /* 188px */
		height: 11.75rem; /* 188px */
	}
	.sub{
		font-size: 2rem; /* 32px */
		font-weight: 600;
		line-height: 2.25rem; /* 36px */	
		color:$fintColor;
		margin-top: 1.5rem; /* 24px */
		text-align: center;
	}
}
@media screen and (max-width: 768px) {//手机版本
	.bannerBox1{
		.bannerCtx{
			min-width: auto;
			max-width: 768px;
			margin: 0 auto;
			position: relative;
			height: 167px;
			.imgsize{
				width: 100%;
				height:127px ;
			}
			.text{
				position: absolute;
				left: 22px;
				font-size: 24px;
				top:35%;
				color:#242F2F;
				.subtext{
					font-size: 12px;
				}
			}
		}
	}
	.iconBox{
		margin: 10px;
		border-radius: 12px;
		margin-top: -50px;
		padding: 20px 0 10px 0;
		.iconItem{
			width: 25%;
			display: flex;
			flex-direction: column;
			text-align: center;
			.iconImg{
				width: 38px;
				height:38px;
			}
			.imgBox{
				margin-bottom:0px;
			}
			.name{
				margin-bottom:10px;
				font-size: 12px;
				line-height: 16px;
			}
		}
	}
	.MemberBenefits{
		.title{
			font-size: 24px;
		}
		.ctxBox{
			margin: 40px 10px;
			border-radius: 22px;
			padding:25px 0 20px 0;
			.subTitle{
				position: absolute;
				background-color:$baseColor;
				color:#fff;
				font-size: 12px;
				font-weight: 600;
				width: 84px;
				line-height: 30px;
				border-radius: 0px 22px 22px 22px;
				top:-15px;
				left:0px;
			}
			.textBox{
				font-size: 12px;
				margin-bottom: 10px;
				span{
					font-size: 16px;
					margin-left: 15px;
				}
			}
		}
	}
	.FeeStandards{
		min-width: auto;
		max-width: 768px;
		justify-content: space-between;
		padding:20px 10px;
		margin-bottom: 0;
		.first{
			width: 49%;
			height: 145px;
			margin:0px; 
			border-radius: 0px 22px 22px 22px;
			.title{
				background-color:#4176DB ;
				color:#fff;
				font-size: 16px;
				line-height: 40px;
				border-radius: 0px 12px 12px 12px;
			}
			&.second .title{
				background-color: $baseColor;
			}
			.ctxbox{
				padding:15px 0 0px 10px;
				.el-icon-success{
					font-size: 20px;
				}
				div{ 
					font-size: 12px;
					margin-bottom: 10px;
					span{
						margin-left:5px ;
						b{
							font-size: 12px;
						}
					}
				}
			}
		}
	}
	.teamBox{
		padding:20px 4px;
		margin: 40px 0;
		.teamtitle{
			font-size: 12px;
			font-weight: 600;
			line-height: 16px;
		}
		.fuhao{
			font-size: 50px;
			color:$baseColor;
			font-weight: 1000;
			margin:0;
			margin-top: -40px;
		}
		.borderimg{
			border:3px solid $baseColor;
			border-radius: 50%;
			width: 40px;
			height: 40px;
			
		}
		.borderimg1{
			width: 48px;
			height: 48px;
		}
		.sub{
			font-size: 12px;
			line-height: 36px;	
			margin-top: 0px;
		}
	}
}
.flex1{
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}
</style>